module.exports = __webpack_public_path__ + "img/yhgh9.c5dd9d6b.png";